module.exports = __webpack_public_path__ + "media/images/application/template/icon--link-external-267bf021bfe2590be55233f348aacfb4.svg";